import { ApolloClient } from "@apollo/client";
import React from "react";
import ExploreIndustriesGrid from "../../components/ExploreIndustriesGrid/ExploreIndustriesGrid";
import Layout from "../../components/Layout/Layout";
import PageHero from "../../components/PageHero/PageHero";
import Sidebar from "../../components/Sidebar/Sidebar";
import { HomeHeader } from "../../components/SiteHeader/SiteHeader";
import { sidebarDataQueries, useSidebarQuery } from "./SidebarQuery";

export default function PageLayoutContainer(props: {
  additionalContent?: React.ReactNode;
  children: React.ReactNode;
  hideFilter?: boolean;
  hideSidebar?: boolean;
  metaDescription?: string;
  metaTitle?: string;
  metaUrl?: string;
}) {
  const { data } = useSidebarQuery();
  const filterBarRef = React.useRef<HTMLDivElement>(null);

  return (
    <Layout
      metaDescription={props.metaDescription}
      metaTitle={props.metaTitle}
      metaUrl={props.metaUrl}
      additionalContent={
        <>
          {props.additionalContent}
          <ExploreIndustriesGrid industries={data?.industries ?? []} />
        </>
      }
      header={
        <HomeHeader
          filterBarRef={filterBarRef}
          industries={data?.industries ?? []}
          topics={data?.topics ?? []}
        />
      }
      hero={
        !props.hideFilter ? (
          <PageHero
            filterBarRef={filterBarRef}
            industries={data?.industries ?? []}
            topics={data?.topics ?? []}
          />
        ) : null
      }
      sidebar={
        !props.hideSidebar && data ? (
          <Sidebar hidden={props.hideSidebar} industries={data.industries} topics={data.topics} />
        ) : null
      }
    >
      {props.children}
    </Layout>
  );
}

PageLayoutContainer.runDataQueries = (apolloClient: ApolloClient<any>) => {
  return sidebarDataQueries(apolloClient);
};
